import {formatDate as _formatDate} from "../../../utils";

export const formatDate = date => (date ? _formatDate(date) : '');